module.exports = __webpack_public_path__ + "img/sailingPlan_success.f783a837.png";